<form class="custom-forms form-horizontal" action="#" method="POST" novalidate="novalidate" id="form_body" [formGroup]="ticketFiltter">
    <div class="row generalSearchSection" >
        <div class="col-lg-12 row">
            <div class="col-lg-6 d-flex reportFilter">
                <!-- customer Name  multiselect -->
                <div class="col-lg-6 d-flex pull-left mr-2">
                    <select formControlName="customer_name"  class="form-control" disabled>
                        <option value="1" hidden>{{cusCode}}-{{cusName}}</option>
                    </select >
                </div>
                <!-- Ticket Status multiselect -->
                <div class="col-lg-6 d-flex pull-left mr-2">
                    <select formControlName="status"  class="form-control">
                        <option value="" hidden>Select Status</option>
                        <option *ngFor="let items of statusList" [value]=items.id>
                            {{items.name}}
                        </option>
               </select>
                </div>
            </div>
            <div class="col-lg-6 d-flex reportFilter">
                <!-- Facility Department multiselect -->
                <div class="col-lg-6 d-flex pull-left mr-2">
                    <ng-multiselect-dropdown style="width: 100%;" class="multidrop" (keydown.enter)="$event.preventDefault()" name="Facility Department" 
                    [placeholder]="'Facility Department '" [data]="facility_department" formControlName="FacilityDepart"
                    [settings]="dropdownFacilityDepartSettings" (onSelect)="onItemSelectFacilityDepart($event)"
                    (onSelectAll)="onSelectAllFacilityDepart($event)" (onDeSelect)="onItemDeSelectFacilityDepart($event)"
                    (onDeSelectAll)="onItemDeSelectAllFacilityDepart($event)">
                  </ng-multiselect-dropdown>
                </div>
                <div class="col-lg-6 d-flex pull-left mr-2">
                    <!-- <label class="control-label" style="margin-right: 35px;">Select Period</label> -->
                    <div class="input-group">
                        <select class="form-control" formControlName="selected_period" (change)="onChangePeriod($event.target.value)">
                        <option value='MTD'>MTD</option>
                        <option value='QTD'>QTD</option>
                        <option value='YTD'>YTD</option>
                        <option value=''>Duration</option>
                        </select>
                    </div>&nbsp;&nbsp;&nbsp;
                </div>
            </div>
        </div>
    </div>
    <div class="row generalSearchSection" >
        <div class="col-lg-12 row">
            <div class="col-lg-6 d-flex reportFilter">
                <div class="col-lg-6">
                    <button class="calenderview w-100" *ngIf="duration_period"> <kt-date [from]="defaultFrom" [to]="defaultTo"
                        (dateRangeSelection)="onDateRangeSelection($event)"></kt-date></button>
              </div>
            </div>
            <div class="col-lg-2 d-flex mr-2 row justify-content-end"></div>
            <div class="col-lg-4 d-flex mr-2 row justify-content-end">
                <!-- asset status report view button -->
                <button type="button" class="views" (click)="getAttendance(1,selectedItemsPerPage1,searchValue)">{{'RAISETCKT.VIEW'|translate}}<img class="export-img"
                    src="assets/media/icons/png/eye.png"></button>
                <!-- asset status report Export button -->
                <button type="button" class="export ml-2" (click)="exportAsAllTicketsReport()">{{'SITE.EXPORT'|translate}}<img class="export-img"
                    src="assets/media/icons/png/xlsx.png"></button>
                <!-- asset status report reset button -->
                <button type="button" class="btn btnFill ml-2" (click)="reset_filters()">Reset</button>
            </div>
        </div>

    </div>
</form>

<div class="kt-section">
    <div class="row" *ngIf="showFilters">
        <div class="col-lg-9"></div>
        <div class="col-lg-3">
                <div class="search-container">
                  <input type="text" placeholder="search here" name="search" class="form-control" [(ngModel)]="searchValue"/>
                  <button (click)="search(searchValue,selectedItemsPerPage1,currentPage1)" class="search-button"></button>
                </div>
        </div>
        <div class="col-lg-9"></div>
        <div class="col-lg-3" style="color: brown;" *ngIf="searchError!=''">
            {{searchError}}
        </div>
    </div>
    <!-- To Display the packages -->
    <div class="row" *ngIf="showAllTicketTable">
        <!-- <div class="table-responsive GeneralTable text-nowrap" *ngIf="!pagination_flag;else normalTemplate">
            <table id="datatables"
            class="table-bordered datatable w-auto mw-100">
                <thead>
                    <tr>
                        <th class="sno">{{'RAISETCKT.SE_NO' | translate}}</th>
                        <th class="tck">{{'NEWTCKT.TCKID' | translate}}</th>
                        <th class="cus">{{'AMC.TAB_SERIAL'|translate}}</th>
                        <th class="cusname">{{'NEWTCKT.CUS_NAME'|translate}}</th>
                        <th class="ass">{{'NEWTCKT.TCH_ID'|translate}}</th>
                        <th class="pro">{{'NEWTCKT.PRODUCT'|translate}}</th>
                        <th class="spro">{{'KNBS.SUBPRO'|translate}}</th>
                        <th class="cdate">{{'CUSTOMER.RAISED_DATE'|translate}} </th>
                        <th class="loc">{{'NEWTCKT.LOCATION'|translate}} </th>
                        <th class="att">{{'RAISETCKT.ATTACH'|translate}}</th>
                        <th class="sta">{{'NEW_SUBSCRIPTION.STATUS'|translate}}</th>
                    </tr>
                </thead>

                <tbody *ngIf="ticket_details?.length != 0">
                    <tr *ngFor="let item of ticket_details;let i=index">
                        <td class="text-center">{{i+1}}</td>
                   <td class="linkButton" style="color: #253F68;" (click)="get_ticket_details(item.ticket_id,view_tcktdetails)">{{item.ticket_id}}</td>
                   <td class="linkButton" (click)="get_barocde_details(item.serial_no)">{{item.serial_no}}</td>
                   <td>{{item.customer_name}}
                   </td>
                   <td><a class="button" (click)="get_technician_details(item.ticket_id,item.technician_id,view_techniciandetails)"  data-placement="bottom" ngbTooltip="View Details">{{ item.technician_name }}</a></td>
                   <td class="url-column" ngbTooltip="{{item.product_name}}" data-container="body"
                       data-placement="bottom" [disableTooltip]="item.product_name.length <= 20">
                       {{((item.product_name.length <= 20) ? item.product_name :
                           item.product_name.substr(0,20) + "..." )}}</td>
                   <td class="url-column" ngbTooltip="{{item.product_sub_name}}" data-container="body"
                       data-placement="bottom" [disableTooltip]="item.product_sub_name.length <= 20" *ngIf="item.product_sub_name!='' && item.product_sub_name!=null">
                       {{(item.product_sub_name.length <= 20) ? item.product_sub_name :
                           item.product_sub_name.substr(0,20) + "..." }}</td>
                   <td *ngIf="item.product_sub_name=='' || item.product_sub_name==null">-</td>
                   <td class="url-column">{{item.raised_date_time}}</td>
                   <td class="url-column" ngbTooltip="{{item.Town}}" data-container="body"
                       data-placement="bottom" [disableTooltip]="item.Town.length <= 20">
                       {{(item.Town.length <= 20) ? item.Town : item.Town.substr(0,20) + "..." }}</td>
                   <td class="datatable-center url-column" >
                       <a style="cursor: pointer;"
                           (click)="attachments(item,attachmentPage)">
                           <img src="assets/media/icons/png/attachment.png">
                       </a>
                   </td>
                   <td class="url-column" ngbTooltip="{{item.status_name}}" data-container="body"
                       data-placement="bottom" [disableTooltip]="item.status_name.length <= 22">{{(item.status_name.length <=
                           22) ? item.status_name : item.status_name.substr(0,22) + "..." }}</td>
                   </tr>
                </tbody>
            </table>
        </div> -->
        <!-- <ng-template #normalTemplate> -->
        <div class="table-responsive GeneralTable text-nowrap">
            <table id="normalDatatables" class="table-bordered datatable w-auto mw-100">
                <thead>
                    <tr>
                        <!-- <th class="sno">{{'RAISETCKT.SE_NO' | translate}}</th>
                        <th class="tck">{{'NEWTCKT.TCKID' | translate}}</th>
                        <th class="cus">{{'AMC.TAB_SERIAL'|translate}}</th>
                        <th class="cusname">{{'NEWTCKT.CUS_NAME'|translate}}</th>
                        <th class="ass">{{'NEWTCKT.TCH_ID'|translate}}</th>
                        <th class="pro">{{'NEWTCKT.PRODUCT'|translate}}</th>
                        <th class="spro">{{'KNBS.SUBPRO'|translate}}</th>
                        <th class="cdate">{{'CUSTOMER.RAISED_DATE'|translate}} </th>
                        <th class="loc">{{'NEWTCKT.LOCATION'|translate}} </th>
                        <th class="att">{{'RAISETCKT.ATTACH'|translate}}</th>
                        <th class="sta">{{'NEW_SUBSCRIPTION.STATUS'|translate}}</th> -->
                    </tr>
                </thead>

                <tbody>
                    <!-- values from the api.For loop to populate the datas -->
                    <tr
                        *ngFor="let item of ticket_details| paginate: { itemsPerPage: selectedItemsPerPage1, currentPage: currentPage1, totalItems: totalRecords1 };let i = index;">
                        <!-- <td class="text-center">{{i+1}}</td>
                        <td class="linkButton" style="color: #253F68;"
                            (click)="get_ticket_details(item.ticket_id,view_tcktdetails)">{{item.ticket_id}}</td>
                        <td class="linkButton" (click)="get_barocde_details(item.serial_no)">{{item.serial_no}}</td>
                        <td>{{item.customer_name}}
                        </td>
                        <td><a class="button"
                                (click)="get_technician_details(item.ticket_id,item.technician_id,view_techniciandetails)"
                                data-placement="bottom" ngbTooltip="View Details">{{ item.technician_name }}</a></td>
                        <td class="url-column" ngbTooltip="{{item.product_name}}" data-container="body"
                            data-placement="bottom" [disableTooltip]="item.product_name.length <= 20">
                            {{((item.product_name.length <= 20) ? item.product_name : item.product_name.substr(0,20)
                                + "..." )}}</td>
                        <td class="url-column" ngbTooltip="{{item.product_sub_name}}" data-container="body"
                            data-placement="bottom" [disableTooltip]="item.product_sub_name.length <= 20"
                            *ngIf="item.product_sub_name!='' && item.product_sub_name!=null">
                            {{(item.product_sub_name.length <= 20) ? item.product_sub_name :
                                item.product_sub_name.substr(0,20) + "..." }}</td>
                        <td *ngIf="item.product_sub_name=='' || item.product_sub_name==null">-</td>
                        <td class="url-column">{{item.raised_date_time}}</td>
                        <td class="url-column" ngbTooltip="{{item.Town}}" data-container="body" data-placement="bottom"
                            [disableTooltip]="item.Town.length <= 20">
                            {{(item.Town.length <= 20) ? item.Town : item.Town.substr(0,20) + "..." }}</td>
                        <td class="datatable-center url-column">
                            <a style="cursor: pointer;" (click)="attachments(item,attachmentPage)">
                                <img src="assets/media/icons/png/attachment.png">
                            </a>
                        </td>
                        <td class="url-column" ngbTooltip="{{item.status_name}}" data-container="body"
                            data-placement="bottom" [disableTooltip]="item.status_name.length <= 22">
                            {{(item.status_name.length <= 22) ? item.status_name : item.status_name.substr(0,22) + "..."
                                }}</td> -->
                    </tr>
                </tbody>
            </table>
            <div class="row">
                <div class="col-sm-6 entries"> <!-- Showing X to Y of Z entries -->
                    <p class="entries">Showing {{ startRecord1 }} to {{ endRecord1 }} of {{ totalRecords1 }} entries
                    </p>
                </div>
                <div class="col-sm-6 text-right"> <!-- Pagination Controls -->
                    <pagination-controls (pageChange)="pagechange($event,selectedItemsPerPage1,searchValue)"
                        [totalItems]="totalRecords1" [itemsPerPage]="itemsPerPage1"></pagination-controls>
                </div>
            </div>
        </div>
        <!-- </ng-template> -->
    </div>
</div>